import { ChartAPIReturn, CreateChartOptions, chartAPI } from '@chart';
import { UseTurboChartReturn } from '@terminal/views/turbo-chart/hooks/use-turbo-chart/useTurboChart';
import type {
  TerminalChartAssetData,
  TerminalPaneData,
} from '@terminal/views/turbo-chart/utils/chart-utils/types';
import { RefObject, useEffect, useRef } from 'react';

export interface UseChartApiProps {
  canvasRef: RefObject<HTMLCanvasElement | null>;
  chartState: UseTurboChartReturn['chartState'];
  options: CreateChartOptions;
  primaryAsset: TerminalChartAssetData;
  primaryPane: TerminalPaneData;
}

export const useChartApi = ({
  canvasRef,
  chartState,
  options,
  primaryAsset,
  primaryPane,
}: UseChartApiProps) => {
  const chartApiRef = useRef<ChartAPIReturn | null>(null);
  useEffect(() => {
    if (canvasRef.current) {
      chartApiRef.current = chartAPI({
        canvasElement: canvasRef.current,
        options,
      });

      chartApiRef.current?.init({
        horizon: chartState.horizon,
        resampleInterval: chartState.resample,
        domain: chartState.domain,
        panes: chartState.chartPanes,
        primaryAsset,
        primaryPaneId: primaryPane.id,
      });
    }

    return () => {
      chartApiRef.current?.removeListeners();
      chartApiRef.current?.reset();
    };
  }, [options.width, options.height, chartState.chartPanes, primaryPane.id]);

  return chartApiRef;
};
